const FlagEnums = {
  OUTGOING: "OUTGOING",
  INCOMING: "INCOMING",
};

export default FlagEnums;
